function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { BIRMINGHAM_MIDSHIRES, BOS, HALIFAX, LLOYDS, LLOYDS2023, MBNA } from "../../constants";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M24 4H0l12 7.087L24 4zm-12 8.59L0 5.61V20h24V5.61l-12 6.98z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,3 C22.1045695,3 23,3.8954305 23,5 L23,5 L23,19 C23,20.1045695 22.1045695,21 21,21 L21,21 L3,21 C1.8954305,21 1,20.1045695 1,19 L1,19 L1,5 C1,3.8954305 1.8954305,3 3,3 L3,3 Z M21,6.414 L13.4142136,14 C12.6742728,14.7399408 11.4987886,14.778885 10.7130012,14.1168328 L10.5857864,14 L3,6.415 L3,19 L21,19 L21,6.414 Z M19.584,5 L4.415,5 L12,12.5857864 L19.584,5 Z",
    fill: "currentColor"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M24 4H0l12 7.087L24 4zm-12 8.59L0 5.61V20h24V5.61l-12 6.98z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 4V20H23V4H1ZM21.7 5.29999V6.29001L12 11.89L2.3 6.29001V5.29999H21.7ZM2.3 18.7V7.79001L12 13.39L21.7 7.79001V18.7H2.3Z",
    fill: "currentColor"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.0008506,0 C18.6281279,0 24,5.37250373 24,11.9991139 C24,18.6265747 18.6281279,24 12.0008506,24 C5.37321897,24 0,18.6265747 0,11.9991139 C0,5.37250373 5.37321897,0 12.0008506,0 Z M19.6751967,15.033894 C20.2183313,14.4684084 20.6451407,13.8025432 20.9546325,13.0324704 C21.2632027,12.2618304 21.4188701,11.4371727 21.4188701,10.556016 C21.4188701,9.30375271 21.1914652,8.18745551 20.7378606,7.20322547 C20.2829801,6.22027145 19.658751,5.38809942 18.8609201,4.7067094 C18.0622386,4.02531937 17.1203658,3.50265097 16.0326788,3.13912954 C14.9468349,2.77341052 13.7717445,2.59242959 12.5066279,2.59242959 C11.172822,2.59242959 9.90720919,2.8229623 8.70986035,3.28232636 C7.51463812,3.74480956 6.46090593,4.40075025 5.55433473,5.25348023 C4.64726731,6.10706089 3.92344226,7.13857423 3.38704189,8.34752404 C2.85049975,9.55831696 2.58304388,10.9145043 2.58304388,12.4142429 C2.58304388,13.8846332 2.81619054,15.1824076 3.28482314,16.3026746 C3.75047849,17.4229416 4.40107748,18.3620859 5.23279223,19.1184771 C6.0644361,19.8757189 7.05004608,20.4456706 8.184093,20.8306006 C9.31764372,21.2158852 10.5524917,21.4089173 11.8862976,21.4089173 C12.6440065,21.4089173 13.3142412,21.3527019 13.8984901,21.2434612 C14.4839441,21.1324482 15.0578436,20.9406921 15.6211101,20.6664205 L14.982491,18.6849877 C14.5691501,18.8780907 14.1081024,19.0212875 13.6005529,19.1184771 C13.0903807,19.2143197 12.6377685,19.2620992 12.2376834,19.2620992 C11.0546537,19.2620992 10.0057418,19.1006129 9.09201106,18.7772858 C8.17735876,18.4548803 7.41036365,17.993744 6.79223081,17.3952947 C6.17197136,16.7959239 5.7009995,16.0724963 5.37818104,15.218065 C5.05578791,14.3658313 4.89345715,13.4025845 4.89345715,12.3300261 C4.89345715,11.2440696 5.08605657,10.2348865 5.47047565,9.3072263 C5.8566669,8.37878631 6.38909761,7.57738034 7.0686893,6.90258304 C7.75054937,6.23012509 8.55107393,5.70036774 9.47331112,5.31409077 C10.3950521,4.92965692 11.3930673,4.73705011 12.4646629,4.73705011 C13.3993762,4.73705011 14.2739066,4.84848843 15.0854895,5.06881304 C15.8958673,5.28736542 16.6013327,5.63564561 17.199759,6.11060537 C17.7969093,6.58372199 18.2686609,7.18621199 18.6129581,7.91410554 C18.9563337,8.64320421 19.1289431,9.52400644 19.1289431,10.556016 C19.1289431,11.2712912 19.0437372,11.8893769 18.8711278,12.4142429 C18.7007868,12.9365568 18.4755795,13.3682031 18.2018147,13.7115919 C17.9253562,14.0568239 17.6157936,14.3109628 17.2724888,14.475072 C16.9299638,14.6410244 16.5776565,14.7230435 16.2209541,14.7230435 C15.8623378,14.7230435 15.6331608,14.5794214 15.5288864,14.290901 C15.4270929,14.0023807 15.4297866,13.5340846 15.5390232,12.8870051 L16.5295243,7.29552362 L15.0854895,7.29552362 L14.446445,7.95642658 C14.1695612,7.72277473 13.8671581,7.53456307 13.5381017,7.3896649 C13.2081236,7.2442705 12.8018005,7.17288476 12.3196994,7.17288476 C11.6196215,7.17288476 10.9556249,7.36244333 10.3308287,7.73971733 C9.70383498,8.11833823 9.15396612,8.61562818 8.6790246,9.23591145 C8.20415397,9.85399713 7.8303679,10.5662241 7.55440561,11.3703239 C7.28099525,12.174849 7.14184447,13.0034057 7.14184447,13.8569863 C7.14184447,14.3109628 7.20698944,14.7230435 7.33898065,15.0950008 C7.46877437,15.4660365 7.64492805,15.7835507 7.86432268,16.0448494 C8.08506415,16.3044468 8.34592755,16.5073326 8.64698377,16.652727 C8.95066279,16.7959239 9.26681789,16.8695072 9.59771745,16.8695072 C10.0093571,16.8695072 10.3870419,16.8065573 10.7317644,16.683564 C11.07514,16.5604289 11.3930673,16.3918536 11.6812221,16.1777673 C11.9697313,15.9646025 12.2345644,15.7202463 12.4754377,15.4454786 C12.7166655,15.1703564 12.9396753,14.8884997 13.1453179,14.6009009 L13.2286099,14.6009009 C13.1857943,15.0253873 13.2134401,15.3844427 13.3106259,15.6724668 C13.4065358,15.961058 13.5545474,16.1947808 13.7543773,16.3744857 C13.9528603,16.5537653 14.2003261,16.6799486 14.4973417,16.7553042 C14.7930106,16.8320066 15.1122847,16.8695072 15.4570072,16.8695072 C16.2806408,16.8695072 17.0552917,16.704051 17.7781243,16.3744857 C18.4992557,16.0448494 19.1324874,15.5971113 19.6751967,15.033894 Z M12.506635,9.31798024 C12.7951443,9.31798024 13.0364429,9.35859993 13.228617,9.44054821 C13.4200113,9.52398517 13.6063727,9.64038576 13.7855745,9.79251466 L13.2696605,12.6395085 C13.1180336,12.9142763 12.9454243,13.175575 12.7541008,13.4235465 C12.5610761,13.6714472 12.3616715,13.8908502 12.156596,14.0826064 C11.9482597,14.2770563 11.7360247,14.4304612 11.5161338,14.5464365 C11.2972354,14.6651055 11.08897,14.7230223 10.8981428,14.7230223 C10.4432622,14.7230223 10.1244134,14.5776279 9.93755582,14.2908798 C9.75161976,14.0001619 9.65925427,13.6299768 9.65925427,13.175575 C9.65925427,12.7349967 9.72794357,12.2854154 9.86617282,11.8247044 C10.0026299,11.3635681 10.1992699,10.9488644 10.4534699,10.5760565 C10.7080953,10.2036738 11.0100021,9.9031023 11.3623095,9.66937957 C11.7124194,9.43395549 12.0932232,9.31798024 12.506635,9.31798024 Z"
  }));
};
MbnaIcon.defaultProps = {
  fill: "currentColor",
  fillRule: "evenodd",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
import React from 'react';
export default function (_ref) {
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var svg;
  switch (brand) {
    case LLOYDS:
      svg = LloydsIcon;
      break;
    case BOS:
      svg = BosIcon;
      break;
    case BIRMINGHAM_MIDSHIRES:
    case HALIFAX:
      svg = HalifaxIcon;
      break;
    case LLOYDS2023:
      svg = Lloyds2023Icon;
      break;
    case MBNA:
      svg = MbnaIcon;
      break;
    default:
      // eslint-disable-next-line no-console
      console.warn("Icon is not available in brand \"".concat(brand, "\"."));
      svg = function svg() {
        return null;
      };
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}